import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 路灯协议列表
	**/
	getLampProtocol( params={} ) {
		return request({
	    url: baseUrl + '/device/getLampProtocol',
	    method: 'GET',
	    params
	  })
	},


	/**
	 * 路灯列表
	 * @param {is_double} 0单灯 1双灯
	 * @param {stg_id} 策略的id
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	lightList( params={} ) {
		return request({
	    url: baseUrl + '/device/lamps',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 路灯详情
	 * @param {lampId} 路灯id
	**/
	lightInfo(id) {
		return request({
	    url: baseUrl + '/device/lampsInfo/'+id,
	    method: 'GET'
	  })
	},

	/**
	 * 路灯添加
	**/
	lightAdd(data){
		return request({
			url: baseUrl + '/device/lamps',
			method:'POST',
			data
		})
	},

	/**
	 * 路灯编辑
	**/
	lightEdit(id,data){
		return request({
			url: baseUrl + '/device/lamps/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 路灯删除
	**/
	lightDel(id){
		return request({
			url: baseUrl + '/device/lamps/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 给路灯分配策略 ms:0自动,1手动
	**/
	lightStrategysSave(id,data){
		return request({
			url: baseUrl + '/device/Strategys/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 路灯控制(1手动)
	**/
	lightControl(id,data){
		return request({
			url: baseUrl + '/device/control/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 路灯设为首页显示
	**/
	lightSetHome(id,data){
		return request({
			url: baseUrl + '/device/SetHome/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 设置倾斜角相对绝对
	**/
	lightSetAngle(id,data){
		return request({
			url: baseUrl + '/device/setAngle/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 回路控制
	 * @param {id} 网关ID
	**/
	lampLoopControl(id,data){
		return request({
			url: baseUrl + '/device/lampLoopControl/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 回路控制
	 * @param {id} 网关ID
	**/
	getLoopList(id) {
		return request({
	    url: baseUrl + '/device/getLoopList/'+id,
	    method: 'GET'
	  })
	},

	/**
	 * 导入文件
	**/
	importExcel(data) {
		return request({
	    url: baseUrl + '/device/importExcel',
	    method:'POST',
		data
	  })
	},

	/**
	 * 批量设置路灯自动手动
	**/
	setAutoControl(data) {
		return request({
	    url: baseUrl + '/device/setAutoControl',
	    method:'POST',
		data
	  })
	},

	/**
	 * 所属用户列表
	**/
	lampUserList( params={} ) {
		return request({
	    url: baseUrl + '/auth/getUser',
	    method: 'GET',
	    params
	  })
	}
}